import { Module } from './@types';

export const parseToolbarContainer = (modules: Module[] | Module[][]) => {
  return modules.map((module) => {
    if (Array.isArray(module)) {
      return module.map(getModuleItem);
    }
    return getModuleItem(module);
  });
};

const getModuleItem = (module: Module) => {
  switch (module) {
    case 'bold':
      return 'bold';
    case 'italic':
      return 'italic';
    case 'underline':
      return 'underline';
    case 'bullet':
      return { list: 'bullet' };
    case 'ordered':
      return { list: 'ordered' };
    case 'link':
      return 'link';
    case 'image':
      return 'image';
  }
};
